import React, { useEffect, useState, useRef } from 'react';
import {
    Dialog,
    DialogContent,
    IconButton,
    Box,
    Avatar,
    Typography,
    Button,
    CircularProgress
} from "@mui/material";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import ReplayIcon from "@mui/icons-material/Replay";
import VideocamIcon from "@mui/icons-material/Videocam";
import MicIcon from "@mui/icons-material/Mic";
import CallEndIcon from "@mui/icons-material/CallEnd";
import customerLogo from '../../public/assets/customerlogo.png'
import { logout } from '../core/services/authService';
import { LOGOUT } from '../core/store/slice/authSlice';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import LeadService from '../core/services/leadsService';
import Slide from '@mui/material/Slide';
import "./vaideoCall.css";
import VideoCallApp from "./VideoCallApp"
import { saveToken, saveUser } from '../core/services/authService';
// import Firebase, { auth, db, storage, messaging, analytics } from '../../public/firebaseConfigGuestCall';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const VideoCallModal = ({ open, setOpen, getAgentData, callPayload, variable, agentDetails, setAgentDetails, firstName, lastName, setFirstName, setLastName, setLoadingButton}) => {
    const [loading, setLoading] = useState(false);
    const [callType, setCallType] = useState(null); // null, 'audio', or 'video'
    const [callData, setCallData] = useState(null);
    const [callAcceptData, setCallAcceptData] = useState(null);
    const receiver_id = agentDetails?.agentDetails?.id
    const caller_id = agentDetails?.customerId
    const dispatch = useDispatch();
    const updateIntervalRef = useRef(null); // To store the interval ID
    const callId = callData?.id


    const startCall = async (type, receiver_id, caller_id, firstName, lastName) => {
        setCallType(type);
        try {
            const callTypeApi = type === "audio" ? "voice" : type;
            const res = await LeadService.initiateWebSingleCall(
                callTypeApi,
                receiver_id,
                caller_id,
                firstName,
                lastName,
            );

            if (res?.data?.success) {
                await setOpen(true);
                saveToken(res?.data?.token);
                saveUser(res?.data);
                debugger

                // Ask for Notification Permission and Retrieve Token
                // const fcmToken = await Firebase.askNotificationPermission();
                // if (fcmToken) {
                //     console.log('FCM Token:', fcmToken);
                //     const response = await LeadService.deviceTokenFirebase(fcmToken);
                //     if (response?.data?.success) {
                //         console.info(response.data.message);
                //         setFirstName('');
                //         setLastName('');
                //         setLoadingButton(false)
                //     } else {
                //         toast.error(response.data.message);
                //     }
                // }
                setCallData(res.data.call)
                updateCallLastActivity(res?.data?.call?.id); // First update
                startCallActivityInterval(res.data.call.id); // Start recurring updates
            }
        } catch (error) {
            toast.error(error.message);
        }
    };
    

    useEffect(() => {
        if (agentDetails) {
            const type = "video"
            startCall(type, receiver_id, caller_id, lastName, firstName)
        }
    }, [agentDetails])

    const updateCallLastActivity = async (call_id) => {
        try {
            const res = await LeadService.updateCallLastActivity(call_id);
            if (res?.data?.success) {
                console.log(res.data.message);
            }
        } catch (error) {
            toast.error(error.message);
        }

    }
    const startCallActivityInterval = (call_id) => {
        // Set interval to call `updateCallLastActivity` every 10 seconds
        if (!updateIntervalRef.current) {
            updateIntervalRef.current = setInterval(() => {
                updateCallLastActivity(call_id);
            }, 10000); // 10 seconds
        }
    };

    const stopCallActivityInterval = () => {
        if (updateIntervalRef.current) {
            clearInterval(updateIntervalRef.current); // Clear the interval
            updateIntervalRef.current = null; // Reset the interval reference
        }
    };

    useEffect(() => {
        if (callPayload.type === "decline_call") {
            handleClickClose(callId);
        }

    }, [callPayload])


    const handleClickClose = async (callId) => {
        try {
            stopCallActivityInterval(); // Stop recurring updates when the call is closed
            setLoading(true)
            const userData = JSON.parse(localStorage.getItem('user'));
            const callerId = userData?.call?.caller_id
            const id = callId || callPayload?.call_id;
            const dataRes = await LeadService.callerCallEnded(callerId, id);
            if (dataRes?.data?.success) {
                toast.success(dataRes.data.message);
                setCallData('')
                setFirstName('');
                setLastName('');
                handleClickLogout();
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                handleClickLogout();
                localStorage.clear();
            } else {
                // toast.error(error.message);
                handleClickLogout();
            }
        }
    }

    const handleClickLogout = async () => {
        try {
            const token = localStorage.getItem("token"); // Retrieve the token
            setLoading(true);
    
            // Stop any active media streams
            if (navigator.mediaDevices) {
                try {
                    const streams = await navigator.mediaDevices.enumerateDevices();
                    const mediaStreams = streams
                        .filter((device) => device.kind === "videoinput" || device.kind === "audioinput")
                        .map((device) => device.deviceId);
    
                    // Get and stop tracks for all active streams
                    mediaStreams.forEach(async (deviceId) => {
                        try {
                            const stream = await navigator.mediaDevices.getUserMedia({
                                video: { deviceId },
                                audio: { deviceId },
                            });
                            const tracks = stream.getTracks();
                            tracks.forEach((track) => track.stop());
                        } catch (err) {
                            console.warn(`Error stopping stream for device ${deviceId}:`, err.message);
                        }
                    });
                    console.log("Camera and microphone streams stopped.");
                } catch (err) {
                    console.error("Error accessing media devices:", err.message);
                }
            }
    
            // Proceed with the logout process
            const res = await logout(token);
            if (res.data.success) {
                setCallData("");
                setFirstName("");
                setLastName("");
                setTimeout(() => {
                    localStorage.clear();
                    sessionStorage.clear();
                    setOpen(false);
                }, 200);
                dispatch(LOGOUT());
            }
        } catch (error) {
            if (error.message === "You have been logged out of the application, please login again to use the application.") {
                localStorage.clear();
                setOpen(false);
                setCallData("");
            } else {
                console.log(error.message);
            }
        } finally {
            setLoading(false);
        }
    };
    
    

    useEffect(() =>{
        if(callAcceptData?.type === 'decline_call'){
            handleClickClose(callId);
        }
    }, [callAcceptData])

    useEffect(() => {
        let intervalId;

        const handleCallAcceptApi = async (call_id, receiver_id) => {
            try {
                const res = await LeadService.isReceiverAccepted(call_id, receiver_id);
                if (res.data.success === true) {
                    setCallAcceptData(res.data);
                    clearInterval(intervalId); // Stop polling when data is received
                } else if (res.data.success === false) {
                    setCallAcceptData(null);
                }
            } catch (error) {
                console.log(error.message);
            }
        };

        // Start polling when `callData` is available
        if (callData?.id, callData?.receiver_id) {
            intervalId = setInterval(() => {
                handleCallAcceptApi(callData?.id, callData?.receiver_id);
            }, 2000); // Call API every 2 seconds
        }
        
        return () => {
            clearInterval(intervalId);
        };
    }, [callData?.id, callData?.receiver_id]);

    return (
        <>
            <Dialog
                open={open}
                fullWidth
                TransitionComponent={Transition}
                maxWidth="sm"
                PaperProps={{
                    style: { borderRadius: 18, overflow: "hidden" },
                }}
            >
                {/* Header */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    p={2}
                    bgcolor="white"
                >
                    <IconButton>
                        {/* <ReplayIcon /> */}
                    </IconButton>
                    <img
                        src={customerLogo}// Replace with your logo path
                        alt="Logo"
                        style={{ height: 55 }}
                    />
                    <IconButton>
                        {/* <PowerSettingsNewIcon /> */}
                    </IconButton>
                </Box>

                {/* Content */}
                <DialogContent
                    style={{
                        textAlign: "center",
                        backgroundColor: "#f5f5f5",
                        padding: "40px 0",
                    }}
                >
                    <Box className='content-center'>
                        <Avatar
                            className='pulse'
                            src={`https://iconnctapp.com/` + getAgentData?.profile_image}
                            alt="User"
                            style={{
                                width: 120,
                                height: 120,
                                margin: "0 auto",
                                border: "4px solid #fff",
                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                            }}
                        />
                    </Box>

                    <Typography
                        variant="h6"
                        color="textPrimary"
                        style={{ marginTop: 16, fontWeight: 500 }}
                    >
                        {getAgentData?.name} {getAgentData?.last_name}
                    </Typography>
                    {/* Ringing... with animated dots */}
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{
                            marginTop: 8,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: 400,
                        }}
                    >
                        Ringing
                        <span className="dot-animate">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </Typography>

                </DialogContent>

                {/* Footer Controls */}
                <Box
                    display="flex"
                    justifyContent="space-evenly"
                    alignItems="center"
                    bgcolor="#3f51b5"
                    padding="16px 0"
                >
                    <IconButton style={{ color: "white" }}>
                        {/* <VideocamIcon /> */}
                    </IconButton>
                    <IconButton
                        style={{
                            backgroundColor: "#f44336",
                            color: "white",
                            padding: 16,
                        }}
                        onClick={() => handleClickClose(callData?.id)}
                    >
                        {loading ? <CircularProgress size={24} style={{ color: "white" }} /> : <CallEndIcon />}
                    </IconButton>
                    <IconButton style={{ color: "white" }}>
                        {/* <MicIcon /> */}
                    </IconButton>
                </Box>
            </Dialog>

            <VideoCallApp callPayload={callPayload} callType={callType} caller_id={caller_id} handleClickClose={handleClickClose} callAcceptData={callAcceptData} callId={callId} />

        </>
    );
};

export default VideoCallModal;
